import { useMemo } from 'react';
import bowser from 'yola-bowser';
import isCompositeImage from 'src/js/modules/common/helpers/is-composite-image';
import selectors from '../../../common/constants/selectors';

const useCompositeItemContainerRect = ({ element, scrollPosition }) =>
  useMemo(() => {
    if (!isCompositeImage(element)) {
      return {
        width: 0,
        height: 0,
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        bottomWithScrollPosition: 0,
        topWithScrollPosition: 0,
      };
    }

    const container = element.closest(selectors.COMPOSITE_GROUP);
    const boundingRect = container.getBoundingClientRect();

    return {
      width: boundingRect.width,
      height: boundingRect.height,
      left: boundingRect.left,
      right: boundingRect.right,
      top: boundingRect.top,
      bottom: boundingRect.bottom,
      topWithScrollPosition: bowser.ios ? boundingRect.top : boundingRect.top + scrollPosition,
    };
  }, [element, scrollPosition]);

export default useCompositeItemContainerRect;
